import { Component, Input } from '@angular/core';
import { AdditionalInformationInputComponent } from '../additional-information-input/additional-information-input.component';

@Component({
    selector: 'app-additional-information-list',
    templateUrl: 'additional-information-list.component.html'
})
export class AdditionalInformationListComponent {
    @Input() additionalInformation: {}[];
    @Input() infoSupModel: {};
    updateInfoSupModel(entityAttribute: any) {
        console.log("change info");
        console.log(entityAttribute);
        console.log(entityAttribute.typeOfChange);
        if (entityAttribute.typeOfChange === AdditionalInformationInputComponent.typeRemove) {
            delete this.infoSupModel[entityAttribute.id];
        } else if (entityAttribute.typeOfChange === AdditionalInformationInputComponent.typeAdd) {
            this.infoSupModel[entityAttribute.id] = {
                'code': entityAttribute.code,
                'value': entityAttribute.value,
                'type': entityAttribute.type,
            };

            console.log(this.infoSupModel);
        }
    }

    getNewModel() {
        console.log("new model");
        return Object.create(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/analysis/additional-information/additional-information-list/additional-information-list.component.ts